import { render, staticRenderFns } from "./added-page.vue?vue&type=template&id=4e45e08f&scoped=true"
import script from "./added-page.js?vue&type=script&lang=js&external"
export * from "./added-page.js?vue&type=script&lang=js&external"
import style0 from "./added-page.scss?vue&type=style&index=0&id=4e45e08f&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e45e08f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins-data/workspace/front-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e45e08f')) {
      api.createRecord('4e45e08f', component.options)
    } else {
      api.reload('4e45e08f', component.options)
    }
    module.hot.accept("./added-page.vue?vue&type=template&id=4e45e08f&scoped=true", function () {
      api.rerender('4e45e08f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/added-page/added-page.vue"
export default component.exports